/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';


const PurchaseOrderVendorDropdown = ({
    field: { name },
    form: { setFieldValue },
    getBranchData,
    getVendorDetails,
    getVendorCode,
    getVendorBills,
    getVendorPurchaseOrder,
    getVehicleData,
    setInitialize,
    ...props
}) => {

    const [vendorData, setVendorData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}/masters/transporterMaster`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setVendorData(response.data.resultSet)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])


    let options = []
    if (vendorData && vendorData.length > 0) {
        vendorData.map((object, index) => {
            let temp = {}
            temp.key = object.transporterCode
            temp.text = object.transporterName
            temp.value = object.transporterCode
            return options[index] = temp
        })
    }

    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value)
        setInitialize && setInitialize(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')

        let vendorObject = vendorData.filter(e => {
            return e.transporterCode === data.value
        })

        getVendorCode && getVendorCode(data.value)

        getVendorBills && getVendorBills(data.value).then(() => { setInitialize && setInitialize(false) })
        getVendorPurchaseOrder && getVendorPurchaseOrder(data.value)

        if (data.value) {
            Axios.get(`${APP_CONSTANTS.BASE_URL}/masters/vendorDetails/${vendorObject[0].transporterMasterId}?customerNumber=${customerNo}&userId=${userId}`, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then((response => {
                    getBranchData && getBranchData(response.data.resultSet.branches)
                    getVendorDetails && getVendorDetails(response.data.resultSet)
                    setIsLoading(false)
                }))
                .catch((error => {
                    console.log(error)
                    setIsLoading(false)
                }))
            let vehdata = JSON.stringify
                ({
                    "customerNumber": customerNo,
                    "userId": userId,
                    "customer_no": customerNo,
                    "user_id": userId,
                    "customerNo": customerNo
                })

            Axios.post(`${APP_CONSTANTS.BASE_URL}masters/vendorMaster/vehicles/${vendorObject[0].transporterMasterId}`, vehdata, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then((response => {
                getVehicleData && getVehicleData(response.data.resultSet)
            }))
                .catch(error => console.log(error))
        }
    }

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            clearable
            loading={isLoading}
            {...props}
            fluid
        />
    )
}


export default PurchaseOrderVendorDropdown